import React from 'react';
import Aux from '../../hoc/Auxiliare';
import _LOCAL_DATE from '../../Models/CampaignDate';

const banner = (props) => {

    let { campaignStatus, promotionCampaign } = props,
        status = campaignStatus,
        // mobileImage = `/resources/images/${promotionCampaign}/banner-mobile.png`,
        // desktopImage = `/resources/images/${promotionCampaign}/banner.png`;
        // mobileImage = `/resources/images/${promotionCampaign}/Header-Kaufland-Ostern-KIPs-2023-mobile-main.png`,
        // desktopImage = `/resources/images/${promotionCampaign}/Header-Kaufland-Ostern-KIPs-2023-desktop-main.png`;
        mobileImage = `/resources/images/${promotionCampaign}/Header-Milka-Glücksrad-AT-Mobile-main.png`,
        desktopImage = `/resources/images/${promotionCampaign}/Header-Milka-Glücksrad-AT-Desktop-main.png`;

    // status = "holding"
    if (status === 'holding') {
        // mobileImage = `/resources/images/${promotionCampaign}/banner-holding-mobile.png`;
        // desktopImage = `/resources/images/${promotionCampaign}/banner-holding.png`;
        // mobileImage = `/resources/images/${promotionCampaign}/Header-Kaufland-Ostern-KIPs-2023-mobile-holding.png`;
        // desktopImage = `/resources/images/${promotionCampaign}/Header-Kaufland-Ostern-KIPs-2023-desktop-holding.png`;
        mobileImage = `/resources/images/${promotionCampaign}/Header-Milka-Glücksrad-AT-Mobile-holding.png`;
        desktopImage = `/resources/images/${promotionCampaign}/Header-Milka-Glücksrad-AT-Desktop-holding.png`;
    } else if (status === 'end') {
        // mobileImage = `/resources/images/${promotionCampaign}/banner-end-mobile.png`;
        // desktopImage = `/resources/images/${promotionCampaign}/banner-end.png`;
        // mobileImage = `/resources/images/${promotionCampaign}/Header-Kaufland-Ostern-KIPs-2023-mobile-end.png`;
        // desktopImage = `/resources/images/${promotionCampaign}/Header-Kaufland-Ostern-KIPs-2023-desktop-end.png`;
        mobileImage = `/resources/images/${promotionCampaign}/Header-Milka-Glücksrad-AT-Mobile-end.png`;
        desktopImage = `/resources/images/${promotionCampaign}/Header-Milka-Glücksrad-AT-Desktop-end.png`;
    }

    console.log('status', status);

    return (
        <Aux>
            <div className="banner__container">
                <div className="image__container">
                    <div className="image__img">
                        <picture>
                            <source srcSet={desktopImage} media="(min-width: 1024px)" />
                            <source srcSet={desktopImage} media="(min-width: 481px)" />
                            <source srcSet={mobileImage} media="(min-width: 200px)" />
                            <img src={desktopImage} alt="Milka Christmas" />
                        </picture>
                        {status === 'main' ? (

                            <img className='home-wheel-animate' src='/resources/images/wheelspin/wheel-animation.webp' alt='wheel animation'/>
                        ) : null
                        } 
                        
                    </div>
                </div>
            </div>
        </Aux>
    );

}

export default banner;